import React, { useState } from 'react';

import { RiErrorWarningLine } from 'react-icons/ri';
import { FiX } from 'react-icons/fi';
import { Button, Headline, Input } from '../../../LegacyV4Components';
import { Modal } from '../../../Default/Modal';

import * as S from './styles';
import { useToast } from '../../../../hooks/toast';

export function CancelPlanModal({
  isShown,
  setIsShown,
  data,
}: {
  isShown: boolean;
  setIsShown(value: boolean): any;
  data: any;
}) {
  const [name, setName] = useState('');
  const { addToast } = useToast();
  data;

  return (
    <Modal modalOpen={isShown} onBackground={() => setIsShown(false)}>
      <>
        <S.ModalWrapper>
          <S.ModalHeader>
            <button
              type="button"
              onClick={() => setIsShown(false)}
              aria-label="default"
            >
              <FiX />
            </button>
          </S.ModalHeader>
          <S.ModalBody>
            <div>
              <RiErrorWarningLine />
            </div>
            <Headline variant="h4">
              Você está prestes a cancelar um plano!
            </Headline>

            <S.Title>
              <p>Ao cancelar o plano você não poderá mais alterar ele.</p>
            </S.Title>
            <S.Title>
              <p>As futuras cobranças serão canceladas!</p>
            </S.Title>
            <S.Confirmation>
              <S.Title>
                <p className="confirmation">
                  Para confirmar sua intenção, digite abaixo o nome do cliente
                  que você deseja cancelar o plano.
                </p>
              </S.Title>
              <Input
                label=""
                placeholder="Nome do cliente aqui"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </S.Confirmation>
            <S.Button>
              <Button
                onClick={() => {
                  setIsShown(false);
                  addToast({
                    type: 'success',
                    title: 'Plano cancelado com sucesso!',
                  });
                }}
                variant="primary"
                color="red"
                size="default"
              >
                Cancelar
              </Button>
            </S.Button>
          </S.ModalBody>
        </S.ModalWrapper>
      </>
    </Modal>
  );
}
